var path = 'app/scripts/modules/core/src/pipeline/config/triggers/pipeline/selectorTemplate.html';
var html = "<pipeline-trigger-options command=\"vm.command\"></pipeline-trigger-options>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/triggers/pipeline/selectorTemplate.html
// module id = 1041
// module chunks = 0